import React, { Fragment, useState } from 'react';

import { Filters as MCSAFilters } from '../sub/dashboard/mcsa/Filters';
import { RecommendedActions as MCSARecommendedActions } from '../sub/dashboard/mcsa/RecommendedActions';
import { Warnings as MCSAWarnings } from '../sub/dashboard/mcsa/Warnings';
import { CognitiveSecurityScore as MCSACognitiveSecurityScore } from '../sub/dashboard/mcsa/CognitiveSecurityScore';
import { DepartmentRiskDistribution as MCSADepartmentRiskDistribution } from '../sub/dashboard/mcsa/DepartmentRiskDistribution';
import { CognitiveAssessmentOverview as MCSACognitiveAssessmentOverview } from '../sub/dashboard/mcsa/CognitiveAssessmentOverview';
import { ScoreTrendAnalysis as MCSAScoreTrendAnalysis } from '../sub/dashboard/mcsa/ScoreTrendAnalysis';
import { RiskClustering as MCSARiskClustering } from '../sub/dashboard/mcsa/RiskClustering';

import { Filters as MBTSFilters } from '../sub/dashboard/mbts/Filters';
import { LeadershipResilience as MBTSLeadershipResilience } from '../sub/dashboard/mbts/LeadershipResilience';
import { Coverage as MBTSCoverage } from '../sub/dashboard/mbts/Coverage';
import { OrganisationalMastery as MBTSOrganisationalMastery } from '../sub/dashboard/mbts/OrganisationalMastery';
import { BreakdownPatterns as MBTSBreakdownPatterns } from '../sub/dashboard/mbts/BreakdownPatterns';
import { ScoreTrendAnalysis as MBTSScoreTrendAnalysis } from '../sub/dashboard/mbts/ScoreTrendAnalysis';
import { AnalysesList as MBTSAnalysesList } from '../sub/dashboard/mbts/AnalysesList';

import { getWhiteLabelingClient } from '../../helpers/misc.helper';

import { EWhiteLabelingClient } from '../../types/misc.enum';

type EDashboardTab = 'mcsa' | 'mbts';

export const Dashboard = () => {

    const [currentTab, setCurrentTab] = useState<EDashboardTab>('mbts');

    const handleTabClick = (tab: EDashboardTab) => {
        if (getWhiteLabelingClient() === EWhiteLabelingClient.RIDLEY_CONSULTING && tab === 'mcsa') {
            return;
        };

        setCurrentTab(tab);
    };

    // useEffect(() => {
    //     if (currentTab === 'mcsa') {
    //         // Dark mode
    //         document.documentElement.setAttribute('data-theme', 'dark');
    //     } else {
    //         // Light mode
    //         document.documentElement.setAttribute('data-theme', 'light');
    //     };
    // }, [currentTab]);

    return (
        <div className='dashboard__page'>
            <div className='dashboard__tabs'>
                <button
                    className={`dashboard__tabs__btn ${currentTab === 'mcsa' ? 'active' : ''}`}
                    onClick={() => handleTabClick('mcsa')}
                    disabled={getWhiteLabelingClient() === EWhiteLabelingClient.RIDLEY_CONSULTING}
                >
                    MCSA
                </button>
                <button
                    className={`dashboard__tabs__btn ${currentTab === 'mbts' ? 'active' : ''}`}
                    onClick={() => handleTabClick('mbts')}
                >
                    MBTS
                </button>
            </div>
            {currentTab === 'mcsa' ? <MCSA /> : <MBTS />}
        </div>
    );
};

const MCSA = () => {
    return (
        <Fragment>
            <MCSAFilters />
            <MCSAWarnings />
            <div className='d-flex gap-xl'>
                <MCSACognitiveSecurityScore />
                <MCSACognitiveAssessmentOverview />
            </div>
            <MCSADepartmentRiskDistribution />
            <div className='d-flex gap-xl'>
                <MCSAScoreTrendAnalysis />
                <MCSARiskClustering />
            </div>
            <MCSARecommendedActions />
        </Fragment>
    );
};

const MBTS = () => {
    return (
        <Fragment>
            <MBTSFilters />
            <div className="dashboard__stats_cards__mbts">
                <MBTSLeadershipResilience />
                <MBTSCoverage />
                <MBTSOrganisationalMastery />
                <MBTSBreakdownPatterns />
                <MBTSScoreTrendAnalysis />
            </div>
            <MBTSAnalysesList />
        </Fragment>
    );
};